import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { toast } from '@codes/ui-kit/components/ui/use-toast';
import { AxiosError } from 'axios';
import { LoaderCircle } from 'lucide-react';

import { createCredentialsByProvider } from '@codes/auth';
import { useWebCoreStore, webCore } from '@codes/web-core';
export const OAuthResponsePage = () => {
    const setIsAuthenticated = useWebCoreStore(state => state.setIsAuthenticated);
    const location = useLocation();
    const navigate = useNavigate();
    const checkLoginResultCalled = useRef(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (checkLoginResultCalled.current) {
            return;
        }
        checkLoginResultCalled.current = true;

        const checkLoginResult = async () => {
            const routeParams = new URLSearchParams(location.search);
            const code = routeParams.get('code') || '';
            const provider = routeParams.get('provider') || '';
            const stateParam = routeParams.get('state') || '';
            const isSuccess = code.length > 5;

            if (isSuccess) {
                await webCore.logout();

                try {
                    await createCredentialsByProvider(provider, code);
                } catch (e) {
                    const axiosError = e as AxiosError<any>;
                    const isTimeOut = axiosError.response?.data?.includes('timeout by invite');
                    const description = t(
                        isTimeOut ? 'auth.create_credentials_timeout_fail' : 'auth.create_credentials_default_fail'
                    );

                    toast({ description });
                    navigate('/auth/login');
                    return;
                }

                setIsAuthenticated(true);

                let redirectTo = '/';
                try {
                    const stateObj = JSON.parse(decodeURIComponent(stateParam));
                    if (stateObj.from) {
                        redirectTo = stateObj.from;
                    }
                } catch {
                    // No state parameter — WorkspaceContextRedirect will handle routing
                }

                navigate(redirectTo, { replace: true });
                return;
            }

            // Error occurred!
            toast({ title: '에러가 발생했습니다.' });
            navigate('/auth/login');
        };

        checkLoginResult();
    }, [location.search, navigate, setIsAuthenticated]);

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center backdrop-blur-sm">
            <LoaderCircle className="h-10 w-10 animate-spin" />
        </div>
    );
};

export default OAuthResponsePage;
